var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// - Import react components
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { grey } from '@material-ui/core/colors';
import SvgCamera from '@material-ui/icons/PhotoCamera';
import Paper from '@material-ui/core/Paper';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import InfiniteScroll from 'react-infinite-scroller';
import { getTranslate } from 'react-localize-redux';
import { List as ImuList } from 'immutable';
import './stream.css';
import PostComponent from 'src/components/post';
import { SliderPost } from 'components/post';
import PostWriteComponent from 'src/components/postWrite';
import UserAvatarComponent from 'src/components/userAvatar';
// - Import API
import * as PostAPI from 'src/api/PostAPI';
// - Import actions
import * as globalActions from 'src/store/actions/globalActions';
import Swiper from 'react-id-swiper';
// var background = require('../../containers/home/possibleBackgrounds/Ice1.jpg')
// - Create StreamComponent component class
var params = {
    slidesPerView: 3,
    spaceBetween: 0,
    slidesPerGroup: 3,
    loop: false,
    loopFillGroupWithBlank: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }
};
var mobileparams = {
    slidesPerView: 2,
    spaceBetween: 10,
    slidesPerGroup: 2,
    loop: false,
    loopFillGroupWithBlank: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }
};
var Slideparams = {
    slidesPerView: 2,
    spaceBetween: 10,
    freeMode: true,
    scrollbar: {
        el: '.swiper-scrollbar',
        dragClass: 'thumbBar',
        hide: false,
    },
};
var StreamComponent = /** @class */ (function (_super) {
    __extends(StreamComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function StreamComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            postWritePrimaryText: {
                color: grey[400],
                cursor: 'text'
            },
            postWtireItem: {
                fontWeight: '200'
            },
            primaryImage: {
                backgroundImage: "url(https://firebasestorage.googleapis.com/v0/b/fileupload-test-93e98.appspot.com/o/WebsiteFileControl%2Fhome.jpg?alt=media&token=1ef058d6-ea40-4362-89e8-0c9b18b2b644)",
                backgroundAttachment: 'fixed',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100%',
                height: '720px',
            }
        };
        /**
         * Open post write
         *
         *
         * @memberof StreamComponent
         */
        _this.handleOpenPostWrite = function () {
            _this.setState({
                openPostWrite: true
            });
        };
        /**
         * Close post write
         *
         *
         * @memberof StreamComponent
         */
        _this.handleClosePostWrite = function () {
            _this.setState({
                openPostWrite: false
            });
        };
        /**
         * Create a list of posts
         * @return {DOM} posts
         */
        _this.postLoad = function () {
            var match = _this.props.match;
            var posts = _this.props.posts;
            var tag = match.params.tag;
            if (posts === undefined || !(posts.keySeq().count() > 0)) {
                return (React.createElement("h1", null, "'Nothing has shared.'"));
            }
            else {
                var postBack_1 = { divided: false, oddPostList: [], evenPostList: [], threePostList: [], fourPostList: [] };
                var parsedPosts_1 = ImuList();
                posts.forEach(function (post) {
                    if (tag) {
                        var regex = new RegExp('#' + tag, 'g');
                        var postMatch = String(post.get('body', '')).match(regex);
                        if (postMatch !== null) {
                            parsedPosts_1 = parsedPosts_1.push(post);
                        }
                    }
                    else {
                        parsedPosts_1 = parsedPosts_1.push(post);
                    }
                });
                var sortedPosts = PostAPI.sortImuObjectsDate(parsedPosts_1);
                if (sortedPosts.count() > -1) {
                    postBack_1.divided = true;
                }
                else {
                    postBack_1.divided = false;
                }
                var index_1 = 1;
                var one = 1;
                var two = 2;
                var three = 3;
                var four = 4;
                sortedPosts.forEach(function (post) {
                    var newPost;
                    if (window.outerWidth < 500) {
                        newPost = (React.createElement("div", { style: { margin: '2%', marginBottom: '1%', marginTop: '1%', width: '500px' }, key: post.get('id') + "-stream-div" },
                            index_1 > 0 || (!postBack_1.divided && index_1 > 0) ? React.createElement("div", { style: { width: '300px', height: '16px' } }) : '',
                            React.createElement(PostComponent, { FontColor: 'black', key: post.get('id') + "-stream-div-post", post: post })));
                    }
                    else {
                        newPost = (React.createElement("div", { style: { margin: '2%', marginBottom: '1%', marginTop: '1%', width: '500px' }, key: post.get('id') + "-stream-div" },
                            index_1 > 0 || (!postBack_1.divided && index_1 > 0) ? React.createElement("div", { style: { width: '300px', height: '16px' } }) : '',
                            React.createElement(SliderPost, { FontColor: 'black', key: post.get('id') + "-stream-div-post", post: post })));
                    }
                    if (index_1 === 0 && postBack_1.divided) {
                        postBack_1.oddPostList.push(newPost);
                    }
                    if (index_1 && _this.props.currentItemId !== post.get('id')) {
                        one += 4;
                        postBack_1.evenPostList.push(newPost);
                    }
                    ++index_1;
                });
                return postBack_1;
            }
        };
        /**
         * Scroll loader
         */
        _this.scrollLoad = function (page) {
            var loadStream = _this.props.loadStream;
            loadStream(page, 0);
        };
        _this.printstuff = function () {
        };
        _this.state = {
            /**
             * It's true if we want to have two column of posts
             */
            divided: false,
            /**
             * If it's true comment will be disabled on post
             */
            disableComments: _this.props.disableComments,
            /**
             * If it's true share will be disabled on post
             */
            disableSharing: _this.props.disableSharing,
            /**
             * If it's true, post write will be open
             */
            openPostWrite: false,
            /**
             * The title of home header
             */
            homeTitle: props.homeTitle,
            /**
             * If there is more post to show {true} or not {false}
             */
            hasMorePosts: true
        };
        // Binding functions to `this`
        _this.postLoad = _this.postLoad.bind(_this);
        _this.handleOpenPostWrite = _this.handleOpenPostWrite.bind(_this);
        _this.handleClosePostWrite = _this.handleClosePostWrite.bind(_this);
        return _this;
    }
    StreamComponent.prototype.componentDidMount = function () {
    };
    StreamComponent.prototype.componentWillMount = function () {
        var setHomeTitle = this.props.setHomeTitle;
        setHomeTitle();
    };
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    StreamComponent.prototype.render = function () {
        var _a = this.props, tag = _a.tag, displayWriting = _a.displayWriting, hasMorePosts = _a.hasMorePosts, translate = _a.translate;
        var postList = this.postLoad();
        if (window.outerWidth > 500) {
            return (React.createElement(InfiniteScroll, { pageStart: 0, loadMore: this.scrollLoad, hasMore: false, useWindow: true },
                React.createElement("div", { style: { margin: 'auto' } },
                    React.createElement("div", { style: { maxWidth: '100%', minWidth: '160px', verticalAlign: 'top', display: 'flex', overflowX: 'auto' } }, postList.evenPostList))));
        }
        return (React.createElement(InfiniteScroll, { pageStart: 0, loadMore: this.scrollLoad, hasMore: false, useWindow: true },
            React.createElement("div", { style: { display: 'flex', overflowX: 'auto' } }, displayWriting && !tag
                ? (React.createElement("div", { style: { display: 'block', textAlign: 'center', width: '75%', margin: 'auto', marginTop: '1%', backgroundColor: '' } },
                    React.createElement(PostWriteComponent, { open: this.state.openPostWrite, onRequestClose: this.handleClosePostWrite, edit: false },
                        React.createElement(Paper, { elevation: 2 },
                            React.createElement(ListItem, { button: true, style: this.styles.postWtireItem, onClick: this.handleOpenPostWrite },
                                React.createElement(UserAvatarComponent, { fullName: this.props.fullName, fileName: this.props.avatar, size: 36 }),
                                React.createElement(ListItemText, { inset: true, primary: React.createElement("span", { style: this.styles.postWritePrimaryText },
                                        " ",
                                        translate('home.postWriteButtonText')) }),
                                React.createElement(ListItemIcon, null,
                                    React.createElement(SvgCamera, null)))),
                        React.createElement("div", { style: { height: '16px' } })),
                    React.createElement("div", { style: { marginTop: '5%', marginBottom: '10%', textAlign: 'center' } },
                        React.createElement("div", { style: { fontFamily: 'Carrois Gothic SC, sans-serif', fontSize: '2.2rem', letterSpacing: '.10em', marginLeft: 'auto', textAlign: 'center' } }, "New Arrivals"),
                        React.createElement("div", { style: { fontFamily: 'Carrois Gothic SC, sans-serif', letterSpacing: '.10em', fontSize: '1.1rem' } }, "Discover artists from around the globe"))))
                : ''),
            React.createElement("div", { style: { margin: 'auto' } },
                React.createElement("div", { style: { maxWidth: '100%', minWidth: '160px', verticalAlign: 'top', display: 'flex', overflowX: 'auto' } },
                    React.createElement(Swiper, __assign({}, Slideparams), postList.evenPostList)))));
    };
    StreamComponent.propTypes = {
        /**
         * If it's true , writing post block will be visible
         */
        displayWriting: PropTypes.bool.isRequired,
        /**
         * A list of post
         */
        posts: PropTypes.object,
        /**
         * The title of home header
         */
        homeTitle: PropTypes.string
    };
    return StreamComponent;
}(Component));
export { StreamComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        setHomeTitle: function () { return dispatch(globalActions.setHeaderTitle(ownProps.homeTitle || '')); },
        showTopLoading: function () { return dispatch(globalActions.showTopLoading()); },
        hideTopLoading: function () { return dispatch(globalActions.hideTopLoading()); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid']);
    var user = state.getIn(['user', 'info', uid]);
    var Scene = state.getIn(['renderer', 'StateScene']);
    var Camera = state.getIn(['renderer', 'StateCamera']);
    return {
        translate: getTranslate(state.get('locale')),
        avatar: user ? user.avatar : '',
        fullName: user ? user.fullName : '',
        Scene: Scene,
        Camera: Camera
    };
};
// - Connect component to redux store
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StreamComponent));



//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPgStream/stream/StreamComponent.tsx
// module id = 1513
// module chunks = 0 1 2 3